module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/inspection-report/inspection-grid/inspection-grid.component.css
// module id = ./src/app/landprocurement/inspection-report/inspection-grid/inspection-grid.component.css
// module chunks = main